module.exports = __webpack_public_path__ + "img/ic24Breed.9e5c13cd.svg";